import script from "./PortalAppHeader.vue3.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortalAppHeader.vue3.vue?vue&type=script&setup=true&lang=ts"

import "./PortalAppHeader.vue3.vue?vue&type=style&index=0&id=4f3687d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f3687d0"]])

export default __exports__